import { Theme } from "@mui/material/styles"

const styleOverrides = (theme: Theme) => {
  return `
  
	`
}

export default styleOverrides
